import { format } from 'date-fns';

export const epochToDateTime = (milliseconds: number): string => {
  return format(new Date(milliseconds), 'HH:mm:ss dd/MM/yyyy').toString();
};
